import { render, staticRenderFns } from "./propaganda.vue?vue&type=template&id=79ae1f1e&scoped=true&"
import script from "./propaganda.vue?vue&type=script&lang=js&"
export * from "./propaganda.vue?vue&type=script&lang=js&"
import style0 from "./propaganda.vue?vue&type=style&index=0&id=79ae1f1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ae1f1e",
  null
  
)

export default component.exports